export const GET_SERVICE_CLIENT = 'GET_SERVICE_CLIENT';
export const GET_SERVICE_CLIENTS = 'GET_SERVICE_CLIENTS';
export const CREATE_SERVICE_CLIENT = 'CREATE_SERVICE_CLIENT';
export const DELETE_SERVICE_CLIENT = 'DELETE_SERVICE_CLIENT';
export const UPDATE_SERVICE_CLIENT = 'UPDATE_SERVICE_CLIENT';
export const CREATE_SERVICE_CLIENT_VEHICLE = 'CREATE_SERVICE_CLIENT_VEHICLE';
export const UPDATE_SERVICE_CLIENT_VEHICLE = 'UPDATE_SERVICE_CLIENT_VEHICLE';
